"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MortgageType = void 0;
var MortgageType;
(function (MortgageType) {
    MortgageType["FirstMortgagee"] = "First Mortgagee";
    MortgageType["SecondMortgagee"] = "Second Mortgagee";
})(MortgageType = exports.MortgageType || (exports.MortgageType = {}));
